<template>
  <div>
    <div class="content-heading">
      <i class="ic-head-icon">
        <img
          src="@/assets/images/sidebar/locations.svg"
          alt="Locations"
          class="h-100"
        />
      </i>
      <h4 class="head-title">Locations</h4>
      <i class="ic-tooltip" id="help"></i>
      <b-popover
        target="help"
        triggers="hover"
        content="Manage your brand and branches in this section."
      ></b-popover>
      <AppTabs :tabs="tabs" />
    </div>
    <div class="estore-body">
      <transition name="component-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";
export default {
  components: {
    AppTabs,
  },
  data() {
    return {
      tabs: [
        {
          name: "Locations",
          href: "/locations",
          access: "estore-locations.locations:topup-estore",
        },
      ],
    };
  },
};
</script>
